import { render, staticRenderFns } from "./PropertyAdd.vue?vue&type=template&id=6adb7738&scoped=true&"
import script from "./PropertyAdd.vue?vue&type=script&lang=js&"
export * from "./PropertyAdd.vue?vue&type=script&lang=js&"
import style0 from "./PropertyAdd.vue?vue&type=style&index=0&id=6adb7738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adb7738",
  null
  
)

export default component.exports